<template>
    <div class="version2-bottom-block">
        <leftBlock></leftBlock>
        <middleBlock></middleBlock>
        <rightMiddle></rightMiddle>
    </div>
</template>

<script>
import leftBlock from './leftBlock.vue'
import middleBlock from './middleBlock.vue'
import rightMiddle from './rightMiddle.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    leftBlock,
    middleBlock,
    rightMiddle
  }
}
</script>
